import React from 'react';

import Trans from 'components/Common/Translation/Trans';
import HelpIcon from 'components/Common/Icons/Help';
import OneyIcon from 'components/Common/Icons/Oney/Oney';
import useOneyWidget from 'hooks/useOneyWidget/useOneyWidget';

import styles from './ProductOneyBanner.module.scss';

type Props = {
  price: number;
};

export default function ProductOneyBanner({ price }: Props): JSX.Element {
  const { showOneyWidget } = useOneyWidget();

  return (
    <p className={styles.container}>
      <Trans
        i18nKey={
          price < 100
            ? 'ONEY_3X_MESSAGE_LESS_THAN_100'
            : 'ONEY_3X_MESSAGE_GREATER_THAN_100'
        }
        namespace={'productPage'}
        additionalComponents={{
          interestFree: <span className={styles.interestFree} />,
          logo: <OneyIcon className={styles.oneyIcon} />,
        }}
      />
      <HelpIcon
        className={styles.helpIcon}
        onClick={() => showOneyWidget({ paymentAmount: price })}
      />
    </p>
  );
}
